import { render, staticRenderFns } from "./newSettlement.vue?vue&type=template&id=3fa87d8e&scoped=true&"
import script from "./newSettlement.vue?vue&type=script&lang=js&"
export * from "./newSettlement.vue?vue&type=script&lang=js&"
import style0 from "./newSettlement.vue?vue&type=style&index=0&id=3fa87d8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa87d8e",
  null
  
)

export default component.exports